import { normalizeRefineParameter } from "../../../helpers/normalizeRefineParameter";

const seoFlagEncoded = "&lt;!--friendly--&gt;";
const seoFlagDecoded = "<!--friendly-->";

export const isSeoFriendly = (headerHTML, isEncoded) =>
  headerHTML.startsWith(isEncoded ? seoFlagEncoded : seoFlagDecoded);

export const removeSeoFlagDecoded = str => {
  const newString = str.replace(seoFlagDecoded, "");

  return newString.trim();
};

export const getNormalizedRefineForSeoImportantFacetConfig = config => {
  const { refinements } = config;
  const facetQuery = refinements
    .map(refinement => `${refinement.facetId}:${refinement.facetValueId}`)
    .join("|");

  return normalizeRefineParameter({ refine: facetQuery });
};
